import req from "../http";

const address = {
  // 取得 縣市
  getCity(params) {
    return req("get", "/BasicInformation/County", params);
  },

  // 取得 行政區
  getDistrict(params) {
    return req("get", "/BasicInformation/District", params);
  },

  // 取得 行政區包含縣市名
  getDistrictFullName(params) {
    return req("get", "/BasicInformation/District/FullName", params);
  }
};

export default address;